'use strict';

var _toConsumableArray = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Ref = require('./ref');

var internals = {};

internals.extendedCheckForValue = function (value, insensitive) {
  var valueType = typeof value;

  if (valueType === 'object') {
    if (value instanceof Date) {
      return function (item) {
        return item instanceof Date && value.getTime() === item.getTime();
      };
    }

    if (Buffer.isBuffer(value)) {
      return function (item) {
        return Buffer.isBuffer(item) && value.length === item.length && value.toString('binary') === item.toString('binary');
      };
    }
  } else if (insensitive && valueType === 'string') {
    var lowercaseValue = value.toLowerCase();
    return function (item) {
      return typeof item === 'string' && lowercaseValue === item.toLowerCase();
    };
  }

  return null;
};

module.exports = /*#__PURE__*/function () {
  function InternalSet(from) {
    _classCallCheck(this, InternalSet);

    this._set = new Set(from);
    this._hasRef = false;
  }

  _createClass(InternalSet, [{
    key: "add",
    value: function add(value, refs) {
      var isRef = Ref.isRef(value);

      if (!isRef && this.has(value, null, null, false)) {
        return this;
      }

      if (refs !== undefined) {
        // If it's a merge, we don't have any refs
        Ref.push(refs, value);
      }

      this._set.add(value);

      this._hasRef |= isRef;
      return this;
    }
  }, {
    key: "merge",
    value: function merge(add, remove) {
      var _iterator = _createForOfIteratorHelper(add._set),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          this.add(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(remove._set),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _item = _step2.value;
          this.remove(_item);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return this;
    }
  }, {
    key: "remove",
    value: function remove(value) {
      this._set.delete(value);

      return this;
    }
  }, {
    key: "has",
    value: function has(value, state, options, insensitive) {
      return !!this.get(value, state, options, insensitive);
    }
  }, {
    key: "get",
    value: function get(value, state, options, insensitive) {
      if (!this._set.size) {
        return false;
      }

      var hasValue = this._set.has(value);

      if (hasValue) {
        return {
          value: value
        };
      }

      var extendedCheck = internals.extendedCheckForValue(value, insensitive);

      if (!extendedCheck) {
        if (state && this._hasRef) {
          var _iterator3 = _createForOfIteratorHelper(this._set),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var item = _step3.value;

              if (Ref.isRef(item)) {
                item = [].concat(item(state.reference || state.parent, options));
                var found = item.indexOf(value);

                if (found >= 0) {
                  return {
                    value: item[found]
                  };
                }
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }

        return false;
      }

      return this._has(value, state, options, extendedCheck);
    }
  }, {
    key: "_has",
    value: function _has(value, state, options, check) {
      var checkRef = !!(state && this._hasRef);

      var isReallyEqual = function isReallyEqual(item) {
        if (value === item) {
          return true;
        }

        return check(item);
      };

      var _iterator4 = _createForOfIteratorHelper(this._set),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;

          if (checkRef && Ref.isRef(item)) {
            // Only resolve references if there is a state, otherwise it's a merge
            item = item(state.reference || state.parent, options);

            if (Array.isArray(item)) {
              var found = item.findIndex(isReallyEqual);

              if (found >= 0) {
                return {
                  value: item[found]
                };
              }

              continue;
            }
          }

          if (isReallyEqual(item)) {
            return {
              value: item
            };
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return false;
    }
  }, {
    key: "values",
    value: function values(options) {
      if (options && options.stripUndefined) {
        var values = [];

        var _iterator5 = _createForOfIteratorHelper(this._set),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var item = _step5.value;

            if (item !== undefined) {
              values.push(item);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        return values;
      }

      return Array.from(this._set);
    }
  }, {
    key: "slice",
    value: function slice() {
      var set = new InternalSet(this._set);
      set._hasRef = this._hasRef;
      return set;
    }
  }, {
    key: "concat",
    value: function concat(source) {
      var set = new InternalSet([].concat(_toConsumableArray(this._set), _toConsumableArray(source._set)));
      set._hasRef = !!(this._hasRef | source._hasRef);
      return set;
    }
  }]);

  return InternalSet;
}();